import React from 'react'
import { Mutation, Query } from 'react-apollo'
import { gql } from 'apollo-boost'
import { Field, Formik } from 'formik'
import * as yup from 'yup'

import TextField from '../TextField'
import UserSelect from '../Users/Select'
import Text from '../Text'
import Button from '../Button'
import Loading from '../Loading'
import Form, { Heading } from '../Form'

const GET_PAGE = gql`
  query page($id: ID!) {
    page(id: $id)
    {
      id
      template {
        id
        key
      }
      owner {
        id
      }
      price
      comments
    }
  }
`

const UPDATE_PAGE = gql`
  mutation updatePage(
  $id: ID!
  $price: Float!
  $owner: ID!
  $comments: String!
  ) {
    updatePage(
      id: $id
      owner: $owner
      price: $price
      comments: $comments
    ) {
      id
    }
  }
`

const validationSchema = yup.object().shape({
  id: yup.string().required('ID is required'),
  owner: yup.string(),
  price: yup.number().positive('Price must be positive'),
  comments: yup.string(),
})

const onSubmit = (values, {setSubmitting}, updatePage) => {
  updatePage({variables: values})
  setSubmitting(false)
}

const Update = ({id, onCompleted, onError}) =>
  <Query
    query={GET_PAGE}
    variables={{id}}
    fetchPolicy='cache-and-network'>
    {({loading, error, data}) => {
      if (loading) return <Loading />
      if (error) return <Text error>{error.message}</Text>
      if (!data.page) return <Text>Nothing was found!</Text>

      return (
        <Mutation
          mutation={UPDATE_PAGE}
          onCompleted={onCompleted}
          onError={onError}>
          {(updatePage, {loading}) =>
            <Formik
              initialValues={{
                id: data.page.id || '',
                template: (data.page.template && data.page.template.key) || '',
                owner: (data.page.owner && data.page.owner.id) || '',
                price: data.page.price || 0,
                comments: data.page.comments || '',
              }}
              validationSchema={validationSchema}
              onSubmit={(values, actions) => onSubmit(values, actions, updatePage)}>
              {({isSubmitting, values}) =>
                <Form>
                  <Text h2 secondary mb={3}>{values.template}</Text>

                  <Heading>General</Heading>
                  <Field component={UserSelect} name='owner' label='Owner' placeholder='Select an owner...' />
                  <Field component={TextField} name='price' label='Price in Dollars' type='number' step='0.01' placeholder='0.00' />

                  <Heading>Help</Heading>
                  <Field component={TextField} name='comments' label='Comments' textArea rows={5} />

                  <Button type='submit' fluid disabled={loading || isSubmitting}>Save</Button>
                </Form>
              }
            </Formik>
          }
        </Mutation>
      )
    }}
  </Query>

export default Update


// WEBPACK FOOTER //
// ./src/components/Pages/Update.js